module.exports = __webpack_public_path__ + "img/ian.b8432376.jpg";